<template>
  <section>
    <main role="main">
      <section class="hero">
        <div class="hero-body">
          <div class="container">
            <div class="columns">
              <div class="column is-7">
                <h1 class="title is-2">
                  Chinchilla Essentials for your new Floof
                </h1>
                <h2 class="subtitle is-4">
                  By providing advice and <strong>safe</strong> product
                  suggestions, we strive to help cultivate a loving environment
                  for chinchillas all around the globe.
                </h2>
                <div class="section is-hidden-mobile">
                  <div class="icon-container">
                    <router-link
                      v-for="(icon, index) in pageIcons"
                      :key="index"
                      :to="{ name: icon.link }"
                    >
                      <b-icon
                        :icon="icon.icon"
                        :size="icon.size"
                        :type="icon.color"
                      />
                    </router-link>
                  </div>
                </div>
              </div>
              <div class="column is-5 has-text-centered splash-image">
                <img
                  class="is-hidden-mobile image-desktop"
                  src="@/assets/chinchilla_side.jpeg"
                  alt="Chinchilla Side"
                />
                <img
                  class="is-hidden-tablet"
                  src="@/assets/chinchilla_baby_and_mother.jpeg"
                  alt="Chinchilla Front"
                />
              </div>
            </div>
          </div>
        </div>
      </section>

      <section class="hero is-medium is-bold is-primary">
        <div class="hero-body">
          <div class="container">
            <div class="has-text-weight-semibold">
              <span class="is-size-1">Floof&nbsp;</span>
              <span class="is-size-5 has-text-grey-lighter">/flo͞of/&nbsp;</span>
              <span
                v-if="speechSupported"
                class="speech-button"
                @click="playSound"
              >
                <b-icon icon="volume-high" />
              </span>
            </div>
            <div class="title is-5 is-italic">noun</div>
            <div class="title is-5 definition">
              1. The cutest pet worthy of endless love and affection.
            </div>
            <div class="has-text-grey-lighter definition-example">
              "The Floof popped at the sight of treats!"
            </div>
          </div>
        </div>
      </section>

      <section class="container">
        <div class="section">
          <h2 class="title is-2 has-text-centered">Only the best products.</h2>

          <div class="columns is-multiline">
            <div class="column">
              <SingleProduct
                :asin="'B00E4KT57G'"
                class="is-6-tablet is-3-desktop"
              />
            </div>
            <div class="column">
              <SingleProduct
                :asin="'B000WFKF9O'"
                class="is-6-tablet is-3-desktop"
              />
            </div>
            <div class="column">
              <SingleProduct
                :asin="'B001FKACXO'"
                class="is-6-tablet is-3-desktop"
              />
            </div>
            <div class="column">
              <SingleProduct
                :asin="'B003AYEHL6'"
                class="is-6-tablet is-3-desktop"
              />
            </div>
          </div>
        </div>
      </section>
    </main>
  </section>
</template>

<script>
import SingleProduct from '@/components/SingleProduct'
import { getPageMeta } from '@/utils'

const meta = {
  pageTitle: 'Home',
  pageDescription:
    'By providing advice and safe product suggestions, we strive to help cultivate a loving environment for chinchillas all around the globe.',
  pageURL: 'http://www.chinchillaessentials.com/',
  pageImg:
    'https://www.chinchillaessentials.com/img/chinchilla_baby_and_mother.jpeg'
}

export default {
  name: 'Home',
  components: {
    SingleProduct
  },
  metaInfo: () => getPageMeta(meta),
  data() {
    return {
      speechSupported: 'speechSynthesis' in window,
      speechLang: 'Google US English',
      speechVoices: [],
      pageIcons: [
        {
          link: 'BabyCare',
          icon: 'baby-buggy',
          size: 'is-large',
          color: 'is-info'
        },
        {
          link: 'Health',
          icon: 'heart-pulse',
          size: 'is-large',
          color: 'is-danger'
        },
        {
          link: 'HousingAndToys',
          icon: 'home-outline',
          size: 'is-large',
          color: 'is-warning'
        },
        {
          link: 'FAQ',
          icon: 'forum',
          size: 'is-large',
          color: 'is-primary'
        }
      ]
    }
  },
  created() {
    if (this.speechSupported) {
      window.speechSynthesis.onvoiceschanged = () => {
        this.speechVoices = window.speechSynthesis.getVoices()
      }
    }
  },
  methods: {
    playSound() {
      let sound = new SpeechSynthesisUtterance('floof')
      sound.voice = this.speechVoices.filter(
        ({ name }) => name === this.speechLang
      )[0]

      window.speechSynthesis.speak(sound)
    }
  }
}
</script>

<style scoped lang="scss">
.speech-button {
  cursor: pointer;
}

.definition {
  margin-bottom: 5px;
}

.definition-example {
  margin-left: 1em;
}

.icon-container {
  display: flex;
  justify-content: space-between;
}

.splash-image {
  img {
    max-height: 300px;
  }

  img.image-desktop {
    -webkit-transform: scaleX(-1);
    transform: scaleX(-1);
  }
}
</style>
